import { render, staticRenderFns } from "./list-merchant-fees.vue?vue&type=template&id=4753f01c&scoped=true"
import script from "./list-merchant-fees.vue?vue&type=script&lang=js"
export * from "./list-merchant-fees.vue?vue&type=script&lang=js"
import style0 from "./list-merchant-fees.vue?vue&type=style&index=0&id=4753f01c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4753f01c",
  null
  
)

export default component.exports